import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const InputToolbar = styled.div`
  width: 316px;
  position: absolute;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background-color: ${theme.color.white};
  border-radius: 4px;
  box-shadow: 0px 6px 10px ${theme.color.grey14};
  z-index: 1600;
  p,
  div,
  span,
  label {
    font-size: ${theme.font.size.small};
    font-family: ${theme.font.family.workSans};
  }
  span.boldAction {
    color: ${theme.color.designSystem.purple70};
    font-weight: ${theme.font.weight.semiBold};
  }
`;

export const Suffix = styled.p`
  color: ${theme.color.designSystem.blackOpacity60};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  margin: 15px 0;
`;
